import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    console.log("Icon Preview Controller Connected")
  }

  // Update the icon preview when the name changes
  update(event) {
    console.log("Update called with value:", event.target.value)
    const name = event.target.value.toLowerCase()
    
    // Make a request to check if we have an icon for this name
    fetch(`/admin/icons/preview?name=${encodeURIComponent(name)}`, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      console.log("Response received:", response)
      return response.text()
    })
    .then(html => {
      console.log("HTML received:", html)
      const container = this.element.querySelector('#icon-preview')
      if (container) {
        container.innerHTML = html
      } else {
        console.error("Could not find #icon-preview container")
      }
    })
    .catch(error => {
      console.error('Error fetching icon preview:', error)
    })
  }
}
